// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__22BMF","col":"styles_col__13Uk6"};